import { type FunctionalComponent, h } from '@stencil/core';


export interface GenericCardDropdownBody {
  dropdownTrigger: Function;
  isMobile: boolean;
  isOutOfCard: boolean;
  isVisible: boolean;
  labelProvider: CallableFunction;
  dropdownTitle: string;
  fitContent?: boolean;
}

export const GenericCardDropdownBody: FunctionalComponent<GenericCardDropdownBody> = (
  props, children
) => {
    const {
      dropdownTrigger,
      isMobile,
      isOutOfCard,
      isVisible,
      labelProvider,
      dropdownTitle,
      fitContent
    } = props;

    const onEnter = (e) => {
        if (e.keyCode === 13) dropdownTrigger(e);
    };




    return (
      <div
        class={{
          'generic-card-dropdown-container': true,
          'generic-card-dropdown-container--active': isOutOfCard || isVisible,

        }}
      >
        <div
          class={{
            'generic-card-dropdown-body': true,
            'generic-card-dropdown-body--active': isOutOfCard || isVisible,
            'generic-card-dropdown-body--active-fit-content': fitContent,
          }}
        >
          <section
            onClick={(e) => dropdownTrigger(e)}
            onKeyDown={(e) => onEnter(e)}
            class="generic-card-dropdown-body-header--mobile"
            data-skip-click-event='true'
            data-card-area='dropdown-header'
            tabindex={isVisible ? '0' : void 0}
          >
            <div>
              <p class="generic-card-dropdown-body-header--mobile__title">
                {labelProvider('card-dropdown.close', 'Close')}
              </p>
              <se-icon
                class="generic-card-dropdown-body-header--mobile__icon"
                size="micro"
              >
              action_close
              </se-icon>
            </div>
          </section>
          <section
            class="generic-card-dropdown-body-header"
            data-skip-click-event='true'
            data-card-area='dropdown-header'
            onClick={(e) =>
              !isMobile ? dropdownTrigger(e) : e.preventDefault()
            }
            onKeyDown={(e) =>
              !isMobile ? onEnter(e) : e.preventDefault()
            }
            tabindex={isVisible && !isMobile ? '0' : void 0}
          >
            <p
              innerHTML={dropdownTitle}
              class="generic-card-dropdown-body-header__title"
            />
            <se-icon
              class="generic-card-dropdown-body-header__icon"
              size="micro"
            >
            arrow2_down
            </se-icon>
          </section>
          <section class="generic-card-dropdown-body-content">
            {children}
          </section>
        </div>
      </div>
    );
};
